var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.932 8.625L17.4 7.393a.91.91 0 01-.333-.809l.212-1.954a1.743 1.743 0 00-1.922-1.923l-1.957.21a.91.91 0 01-.81-.334l-1.23-1.53a1.798 1.798 0 00-2.72 0l-1.23 1.53a.905.905 0 01-.81.334l-1.954-.21a1.743 1.743 0 00-1.923 1.922l.212 1.954a.906.906 0 01-.333.81L1.068 8.625a1.743 1.743 0 000 2.718L2.6 12.575a.907.907 0 01.333.81l-.212 1.953a1.743 1.743 0 001.922 1.924l1.955-.213a.91.91 0 01.81.334l1.233 1.534a1.743 1.743 0 002.718 0l1.232-1.532a.91.91 0 01.809-.333l1.954.212a1.743 1.743 0 001.924-1.922l-.213-1.955a.905.905 0 01.333-.81l1.532-1.231a1.743 1.743 0 000-2.718zm-8.599 3.915a1.488 1.488 0 01-2.219.158l-2.036-2.031a.833.833 0 111.178-1.179l1.876 1.876 3.257-4.342a.833.833 0 111.334 1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.ae7415ed.svg";
export { ForwardRef as ReactComponent };